import { GENERAL_MARKETS_KEYS } from '../constants';
import { formatCurrencyToNumber, formatDate } from '../helpers';

import {
  FiltersDTO,
  GenerateFiltersFactory,
  Intervals,
  RealtyProgram,
} from '../types';

export const generateFiltersFactory: GenerateFiltersFactory = (
  intervals: Intervals,
  market: string,
  realtyProgram: RealtyProgram
): FiltersDTO | null => {
  const {
    pricePerSquareMt,
    privateAreaInterval,
    unitPrice,
    timeframe,
    realtyAge,
  }: Intervals = intervals;

  const formattedFilters: FiltersDTO = {};
  const addPrivateAreaInterval = (): void => {
    if (privateAreaInterval?.max && privateAreaInterval?.min) {
      formattedFilters.min_private_area = Number(
        privateAreaInterval?.min.replaceAll(',', '.')
      );
      formattedFilters.max_private_area = Number(
        privateAreaInterval?.max.replaceAll(',', '.')
      );
    }
  };

  const addPricePerSquareMtInterval = (): void => {
    if ((pricePerSquareMt?.min || pricePerSquareMt?.max) !== '') {
      const minValue = formatCurrencyToNumber(pricePerSquareMt?.min);
      const maxValue = formatCurrencyToNumber(pricePerSquareMt?.max);

      formattedFilters.min_sqr_mt_price = minValue;
      formattedFilters.max_sqr_mt_price = maxValue;
    }
  };

  const addUnitPriceInterval = (): void => {
    if ((unitPrice?.min || unitPrice?.max) !== '') {
      const minValue = formatCurrencyToNumber(unitPrice?.min);
      const maxValue = formatCurrencyToNumber(unitPrice?.max);

      formattedFilters.min_transaction_price = minValue;
      formattedFilters.max_transaction_price = maxValue;
    }
  };

  const addTimeframeInterval = (): void => {
    if (timeframe && timeframe?.max && timeframe?.min) {
      formattedFilters.min_date = formatDate(timeframe.min.toString());
      formattedFilters.max_date = formatDate(timeframe.max.toString());
    }
  };

  const addRealtyAgeInterval = (): void => {
    if ((realtyAge?.min || realtyAge?.max) !== '') {
      formattedFilters.min_real_estate_age = Number(realtyAge?.min);
      formattedFilters.max_real_estate_age = Number(realtyAge?.max);
    }
  };

  const addRealtyAge = (): void => {
    if (realtyAge && realtyAge?.max && realtyAge?.min) {
      formattedFilters.min_age = Number(realtyAge?.min);
      formattedFilters.max_age = Number(realtyAge?.max);
    }
  };

  const addFiltersByMarket = (): void => {
    switch (market) {
      case GENERAL_MARKETS_KEYS.primary:
        addPrivateAreaInterval();
        break;
      case GENERAL_MARKETS_KEYS.secondary:
        addPrivateAreaInterval();
        addPricePerSquareMtInterval();
        addUnitPriceInterval();
        addTimeframeInterval();
        addRealtyAgeInterval();
        break;
      case GENERAL_MARKETS_KEYS.transactions:
        addPrivateAreaInterval();
        addTimeframeInterval();
        addRealtyAge();
        break;
      default:
        break;
    }
  };

  addFiltersByMarket();

  return { ...formattedFilters, ...realtyProgram };
};
